import { useAppStateContext } from '../../hooks/context';
import AppLayout from '../../layout/AppLayout';
import AppHead from '../AppHead';
import AppServicesList from '../AppServicesList/AppServicesList';

export default function Services({ page }) {
  const { parameters } = useAppStateContext().context;

  const serviceTitle = parameters?.data?.find((x) => x.keyword === 'services_title')?.value;
  const serviceDesc = parameters?.data?.find((x) => x.keyword === 'services_description')?.value;

  return (
    <AppLayout localesUrls={page.language_urls}>
      <AppHead
        metaTitle={page.meta?.title || serviceTitle}
        metaDescription={page.meta?.description}
        language_urls={page.language_urls}
      />
      <AppServicesList services={page} title={serviceTitle} desc={serviceDesc}/>
    </AppLayout>
  );
}
